module.exports = __webpack_public_path__ + "img/OBCINA SVETA TROJICA V SLOVENSKIH GORICAH.399a1387.png";